"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _react = _interopRequireWildcard(require("react"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _theme = require("../../../theme");
var _Button = _interopRequireDefault(require("../../../components/Button"));
var _Download = _interopRequireDefault(require("@mui/icons-material/Download"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _Tooltip = _interopRequireDefault(require("../../../components/Tooltip"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
var _MessageCard = _interopRequireDefault(require("../../../components/Cards/MessageCard"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AvailableProducts = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(AvailableProducts, _PureComponent);
  function AvailableProducts() {
    (0, _classCallCheck2["default"])(this, AvailableProducts);
    return _callSuper(this, AvailableProducts, arguments);
  }
  (0, _createClass2["default"])(AvailableProducts, [{
    key: "render",
    value: function render() {
      var _this = this;
      var styles = {
        container: {
          display: 'flex',
          flexWrap: 'wrap',
          margin: '0 auto',
          justifyContent: 'space-between'
        },
        titleBlock: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 10
        },
        block: {
          width: "calc(50% - 10px)",
          display: 'flex',
          flexDirection: 'column',
          padding: 20,
          marginTop: 20,
          border: "1px solid ".concat(_theme.colors.lightGrey),
          backgroundColor: _theme.colors.surface
        },
        inline: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }
      };
      var availableProductIDs = Object.keys(this.props.availableProducts);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.titleBlock
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        margin: "0 0 -10px 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.availableProducts))), /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.marketplace.optionalVsVoluntary),
        subtitle: _i18n["default"].t(_tokens["default"].labels.marketplace.optionalVsVoluntaryDesc)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.container
      }, availableProductIDs.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.noProductsAvailable)) : availableProductIDs.map(function (productID) {
        var product = _this.props.availableProducts[productID];
        var productAlreadyPurchased = false;
        var productPurchasedForPrimaryOnly = false;
        if (_this.props.purchasedProducts[productID] && _this.props.purchasedProducts[productID].primary.effectiveDate) {
          var purchasedProduct = _this.props.purchasedProducts[productID];
          productAlreadyPurchased = true;

          // if it's an optional benefits, they cannot change the coverage once purchased. The below code is only for voluntary benefits.
          if (product.type.toUpperCase() === 'VOLUNTARY') {
            var now = dates.getUTC();
            var primaryRenewalDate = purchasedProduct.primary ? dates.getFutureDate(purchasedProduct.primary.effectiveDate, 1, "years") : null;

            // if the product is purchased but not for any dependents then mark it as just purchased for the primary
            if ((!purchasedProduct.dependent || !purchasedProduct.dependent.active) && (!purchasedProduct.spouse || !purchasedProduct.spouse.active) && (!purchasedProduct.child || !purchasedProduct.child.active)) {
              productPurchasedForPrimaryOnly = true;
            }
            if (primaryRenewalDate && now > primaryRenewalDate) {
              productAlreadyPurchased = false;
              productPurchasedForPrimaryOnly = false;
            }

            // if the product does not include dependent coverage we can mark that it is not purchased for primary only as it always is
            if (product.primaryOnlyProduct === 1) {
              productPurchasedForPrimaryOnly = false;
            }
          }
        }
        var carrier = product.carrier[_this.props.member.language];
        var name = "".concat(product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.voluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.optional), " ").concat(product.name.primary[_this.props.member.language]);
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.block
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          large: true,
          bold: true,
          margin: "0 0 5px 0"
        }, name), carrier && carrier !== name && /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.inline
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          tiny: true,
          margin: "0 5px 0 0"
        }, _i18n["default"].t(_tokens["default"].labels.marketplace.carrier), ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          tiny: true,
          bold: true
        }, carrier)), product.enrolmentType === 'closed' && product.enrolmentWindowStart && product.enrolmentWindowEnd && /*#__PURE__*/_react["default"].createElement("div", {
          style: _objectSpread(_objectSpread({}, styles.inline), {}, {
            marginBottom: 10
          })
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          tiny: true,
          margin: "0 5px 0 0"
        }, _i18n["default"].t(_tokens["default"].labels.marketplace.enrolmentWindow), ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          tiny: true,
          bold: true
        }, dates.getStartOfDay(product.enrolmentWindowStart, "ll", _i18n["default"].locale), " ", _i18n["default"].t(_tokens["default"].labels.claimSummary.to), " ", dates.getStartOfDay(product.enrolmentWindowEnd, "ll", _i18n["default"].locale)), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          tip: _i18n["default"].t(_tokens["default"].labels.marketplace.purchaseWithinTimePeriod),
          arrow: true
        }, /*#__PURE__*/_react["default"].createElement(_Info["default"], {
          style: {
            marginLeft: 5,
            fontSize: 14,
            color: 'inherit'
          }
        }), "\xA0")), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            flex: 1,
            marginBottom: 5,
            marginTop: 5
          }
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          light: true,
          small: true
        }, product.description[_this.props.member.language])), /*#__PURE__*/_react["default"].createElement("div", {
          style: _objectSpread(_objectSpread({}, styles.inline), {}, {
            justifyContent: 'flex-end'
          })
        }, product.enBrochure && _this.props.member.language === 'en' && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          transparent: true,
          customStyle: {
            marginRight: '10px',
            fontSize: 14
          },
          onClick: function onClick() {
            return window.open(product.enBrochure, "_blank");
          }
        }, /*#__PURE__*/_react["default"].createElement(_Download["default"], {
          style: {
            fontSize: 18,
            color: 'inherit'
          }
        }), "\xA0", _i18n["default"].t(_tokens["default"].labels.marketplace.downloadBrochure)), product.frBrochure && _this.props.member.language === 'fr' && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          transparent: true,
          customStyle: {
            marginRight: '10px',
            fontSize: 14
          },
          onClick: function onClick() {
            return window.open(product.frBrochure, "_blank");
          }
        }, /*#__PURE__*/_react["default"].createElement(_Download["default"], {
          style: {
            fontSize: 18,
            color: 'inherit'
          }
        }), "\xA0", _i18n["default"].t(_tokens["default"].labels.marketplace.downloadBrochure)), productAlreadyPurchased && !productPurchasedForPrimaryOnly ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          color: "primary",
          customStyle: {
            width: 120
          },
          disabled: true
        }, _i18n["default"].t(_tokens["default"].buttons.purchased)) : productPurchasedForPrimaryOnly ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          color: "primary",
          customStyle: {
            width: "auto"
          },
          onClick: function onClick() {
            return _this.props.selectProduct(product.productID);
          },
          disabled: !_this.props.hasBanking
        }, _i18n["default"].t(_tokens["default"].buttons.buyForDependents)) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          color: "primary",
          customStyle: {
            width: 100
          },
          onClick: function onClick() {
            return _this.props.selectProduct(product.productID);
          },
          disabled: !_this.props.hasBanking
        }, _i18n["default"].t(_tokens["default"].buttons.buy))));
      })));
    }
  }]);
  return AvailableProducts;
}(_react.PureComponent);
var _default = exports["default"] = AvailableProducts;